// extracted by mini-css-extract-plugin
export default {"form__admin":"style_form__admin__NaGf9","form__order":"style_form__order__I4clb","form__userProfile":"style_form__userProfile__NQww5"};